import Jaoa from './Jaoa.vue'
import Cbs from './Cbs.vue'
import Home from './Home.vue'
import TheDO from './TheDO.vue'

export default {
  '/': Home,
  '/jaoa': Jaoa,
  '/cbs': Cbs,
  '/the-do': TheDO,
}



// WEBPACK FOOTER //
// ./src/routes.js